import { render, staticRenderFns } from "./commonFooter.vue?vue&type=template&id=5b3c03ae&scoped=true&"
import script from "./commonFooter.vue?vue&type=script&lang=js&"
export * from "./commonFooter.vue?vue&type=script&lang=js&"
import style0 from "./commonFooter.vue?vue&type=style&index=0&id=5b3c03ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3c03ae",
  null
  
)

export default component.exports